import { Conditional } from '@cat-ecom/pcc-components';
import ContactYourDealerPopover from 'components/contact-your-dealer/contact-your-dealer-popover/contact-your-dealer-popover';
import { availabilityByDateContentTypes } from './types';
import { isEmpty } from '@cat-ecom/common/utils/commonUtils';
import styles from './availability-by-date-content.module.scss';
import cx from 'classnames';

const AvailabilityByDateContent = ({
  address,
  message,
  quantityAvailable,
  showContactDealerPopUp
}: availabilityByDateContentTypes) => {
  return (
    <p
      className={cx(
        'cat-u-theme-typography-body-sm cat-u-margin-none d-grid',
        styles['p-grid-columns']
      )}
    >
      <span
        className={cx(
          'fw-bolder cat-u-margin-right-sm',
          styles['span--text-end']
        )}
        data-testid="availability-by-date-quantity"
      >
        {quantityAvailable}:
      </span>
      <Conditional
        test={showContactDealerPopUp || isEmpty(message)}
        fallback={message}
      >
        <ContactYourDealerPopover
          variant="inline"
          dealerAddress={address}
          className="d-inline-block"
          position="bottom-start"
          size="md"
          msg={message}
          shouldFitContent
        />
      </Conditional>
    </p>
  );
};

export default AvailabilityByDateContent;
